<template>
    <quill-editor ref="editor" :content="$props.content" :options="options" v-bind="$attrs"
                  @update:content="$emit('update:content', $event)">
    </quill-editor>
</template>
<script>
import 'quill-image-uploader/dist/quill.imageUploader.min.css';

export default {
    name: "QuillEditorWithUpload",
    expose: ['getQuill'],
    props: {
        content: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            options: {
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                            ['blockquote', 'code-block'],

                            [{'list': 'ordered'}, {'list': 'bullet'}],
                            [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript

                            [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
                            [{'header': [1, 2, 3, 4, 5, 6, false]}],

                            [{'color': []}, {'background': []}],          // dropdown with defaults from theme
                            [{'align': []}],

                            ['clean'],                                         // remove formatting button

                            ['link', 'image']                         // link and image, video
                        ],
                        handlers: {
                            image: this.imageHandler,
                        }
                    }
                }
            }
        }
    },
    methods: {
        getQuill() {
            return this.$refs.editor.getQuill()
        },
        imageHandler() {
            const quill = this.$refs.editor.getQuill()

            const input = document.createElement('input');

            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.click();

            input.onchange = async () => {
                const file = input.files[0];
                const formData = new FormData();

                formData.append('image', file);

                // Save current cursor state
                const range = quill.getSelection(true);

                // Insert temporary loading placeholder image
                quill.insertEmbed(range.index, 'image', 'https://i.gifer.com/ZKZg.gif');

                // Move cursor to right side of image (easier to continue typing)
                quill.setSelection(range.index + 1);

                const res = await this.uploadImage(formData);

                // Remove placeholder image
                quill.deleteText(range.index, 1);
                // Insert uploaded image
                quill.insertEmbed(range.index, 'image', res.data);

            }
        },
        uploadImage(formData) {
            return axios({
                method: 'POST',
                url: '/admin/api/upload-image',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                data: formData
            });
        }
    },
}
</script>

<style scoped>

</style>
